export default __webpack_public_path__ + "static/145-04ee89a096c5e8104005cc00a214cd67.jpg";